(()=>{
  'use strict';

  function setFilterDefaults(scope=document){
    scope.querySelectorAll('[data-tgsa-drawer="filters"]').forEach(drawer=>{
      const groups=[...drawer.querySelectorAll('.tgsa-filter-group')];
      groups.forEach((group,index)=>{
        group.open=index===0;
      });
    });
  }

  function init(){
    setFilterDefaults();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }

  document.addEventListener('shopify:section:load',init);
  document.addEventListener('click',event=>{
    if(event.target.closest('[data-tgsa-open="filters"]')){
      requestAnimationFrame(()=>setFilterDefaults());
    }
  });
})();